var _excluded = ["name", "loading", "errorMessage", "description", "value", "label", "disabled", "isValid", "isEmpty", "mode", "before", "after", "type", "children", "inputStyle", "wrapperStyle", "maxlength"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { useFela } from 'react-fela';
import Box from '../box';
import Loading from '../loading';
import Message from '../message';
import Text from '../text';
var containerStyle = function containerStyle(_ref) {
  var theme = _ref.theme,
    isValid = _ref.isValid,
    hasLabel = _ref.hasLabel,
    isEmpty = _ref.isEmpty,
    labelId = _ref.labelId,
    mode = _ref.mode,
    isDatePicker = _ref.isDatePicker;
  return {
    backgroundColor: 'background.primary',
    position: 'relative',
    borderRadius: theme.tokens.cornersSmall,
    '::after': {
      content: '" "',
      boxSizing: 'border-box',
      pointerEvents: 'none',
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: theme.tokens.cornersSmall,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'border'
    },
    ':focus-within::after': {
      borderWidth: 2,
      borderColor: theme.colors.foreground.primary
    },
    extend: [{
      condition: !isValid,
      style: {
        '::after': {
          borderColor: theme.colors.foreground.destructive,
          borderWidth: 2
        }
      }
    }, {
      condition: hasLabel,
      style: _defineProperty(_defineProperty({}, "& #".concat(labelId), {
        transform: "translateY(27px)",
        fontSize: 12
      }), "extend", {
        condition: isEmpty && !isDatePicker,
        style: _defineProperty({}, ":not(:focus-within) #".concat(labelId), {
          transform: "translateY(36px)",
          fontSize: 16
        })
      })
    }, {
      condition: mode === 'compact' && hasLabel,
      style: _defineProperty(_defineProperty({}, "& #".concat(labelId), {
        transform: "translateY(23px)"
      }), "extend", {
        condition: isEmpty && !isDatePicker,
        style: _defineProperty({}, ":not(:focus-within) #".concat(labelId), {
          transform: "translateY(30px)"
        })
      })
    }]
  };
};
var wrapperStyle = function wrapperStyle(_ref2) {
  var theme = _ref2.theme,
    disabled = _ref2.disabled,
    extend = _ref2.extend;
  return {
    borderRadius: theme.tokens.cornersSmall,
    paddingLeft: theme.tokens.inputPaddingHorizontal,
    extend: [{
      condition: disabled,
      style: {
        color: theme.colors.foreground.disabled,
        backgroundColor: theme.tokens.inputDisabledBackground,
        cursor: 'not-allowed'
      }
    }, extend]
  };
};
var labelStyle = function labelStyle(_ref3) {
  var theme = _ref3.theme,
    loading = _ref3.loading,
    disabled = _ref3.disabled;
  return {
    pointerEvents: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: theme.tokens.inputPaddingHorizontal,
    transitionProperty: 'transform, font-size',
    transitionDuration: '80ms',
    height: 18,
    marginTop: -18,
    lineHeight: 1,
    color: 'foreground.tertiary',
    fontFamily: theme.fonts.BODY,
    fontWeight: 400,
    extend: [{
      condition: loading,
      style: {
        visibility: 'hidden'
      }
    }, {
      condition: disabled,
      style: {
        color: theme.colors.foreground.disabled
      }
    }]
  };
};
export var inputStyle = function inputStyle(_ref4) {
  var theme = _ref4.theme,
    isValid = _ref4.isValid,
    disabled = _ref4.disabled,
    loading = _ref4.loading,
    mode = _ref4.mode,
    hasLabel = _ref4.hasLabel,
    isEmpty = _ref4.isEmpty,
    isDatePicker = _ref4.isDatePicker,
    extend = _ref4.extend;
  return {
    className: 'input',
    display: 'flex',
    boxSizing: 'border-box',
    outline: 0,
    border: 0,
    flexShrink: 1,
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    appearance: 'none',
    background: 'transparent',
    marginTop: theme.tokens.inputPaddingVertical,
    paddingBottom: theme.tokens.inputPaddingVertical,
    paddingRight: theme.tokens.inputPaddingHorizontal,
    color: theme.colors.foreground.primary,
    fontFamily: theme.fonts.BODY,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: isDatePicker ? 1 : 1.25,
    '::placeholder': {
      color: theme.colors.eucalyptus400
    },
    extend: [{
      condition: !isValid,
      style: {
        color: theme.colors.foreground.destructive,
        ':focus': {
          color: theme.colors.foreground.primary
        }
      }
    }, {
      condition: loading,
      style: {
        visibility: 'hidden'
      }
    }, {
      condition: disabled,
      style: {
        cursor: 'not-allowed'
      }
    }, {
      condition: isEmpty && !isDatePicker,
      style: {
        ':not(:focus)': {
          color: 'transparent'
        }
      }
    }, {
      condition: hasLabel,
      style: {
        marginTop: 24,
        paddingBottom: 8,
        '::placeholder': {
          color: 'transparent'
        },
        ':focus': {
          '::placeholder': {
            color: theme.colors.eucalyptus400
          }
        }
      }
    }, {
      condition: mode === 'compact' && !hasLabel,
      style: {
        marginTop: theme.tokens.inputPaddingVertical - 6,
        paddingBottom: theme.tokens.inputPaddingVertical - 6
      }
    }, {
      condition: mode === 'compact' && hasLabel,
      style: {
        marginTop: 16,
        paddingBottom: 4
      }
    }, extend]
  };
};

// eslint-disable-next-line no-extra-boolean-cast
var defaultIsEmpty = function defaultIsEmpty(value) {
  return !Boolean(value) || value < 0;
};
export default function BaseInput(_ref5) {
  var name = _ref5.name,
    loading = _ref5.loading,
    errorMessage = _ref5.errorMessage,
    description = _ref5.description,
    _ref5$value = _ref5.value,
    value = _ref5$value === void 0 ? '' : _ref5$value,
    _ref5$label = _ref5.label,
    label = _ref5$label === void 0 ? '' : _ref5$label,
    disabled = _ref5.disabled,
    isValid = _ref5.isValid,
    _ref5$isEmpty = _ref5.isEmpty,
    empty = _ref5$isEmpty === void 0 ? defaultIsEmpty : _ref5$isEmpty,
    mode = _ref5.mode,
    before = _ref5.before,
    after = _ref5.after,
    type = _ref5.type,
    children = _ref5.children,
    extendInputStyle = _ref5.inputStyle,
    extendWrapperStyle = _ref5.wrapperStyle,
    maxlength = _ref5.maxlength,
    props = _objectWithoutProperties(_ref5, _excluded);
  var hasLabel = label.length > 0;
  var labelId = name + '-label';
  var isEmpty = empty(value);
  var isDatePicker = type && type.match(/^(date|week)/) !== null;
  var styleProps = {
    isValid: isValid,
    disabled: disabled,
    loading: loading,
    mode: mode,
    hasLabel: hasLabel,
    labelId: labelId,
    isEmpty: isEmpty,
    isDatePicker: isDatePicker,
    extend: extendInputStyle
  };
  var _useFela = useFela(styleProps),
    css = _useFela.css,
    theme = _useFela.theme;
  var inputProps = {
    className: css(inputStyle),
    name: name,
    id: name,
    disabled: loading || disabled,
    type: type,
    value: value
  };
  if (hasLabel) {
    inputProps['aria-labelledby'] = labelId;
  }
  return /*#__PURE__*/React.createElement(Box, {
    space: 2,
    width: "100%",
    shrink: 1,
    "data-test": props['data-test']
  }, /*#__PURE__*/React.createElement(Box, {
    shrink: 1,
    direction: "row",
    extend: containerStyle({
      theme: theme,
      isValid: isValid,
      isEmpty: isEmpty,
      hasLabel: hasLabel,
      labelId: labelId,
      mode: mode,
      isDatePicker: isDatePicker
    })
  }, /*#__PURE__*/React.createElement(Box, {
    as: "label",
    htmlFor: name,
    direction: "row",
    maxWidth: "100%",
    grow: 1,
    shrink: 1,
    space: 4,
    alignItems: "center",
    extend: wrapperStyle({
      theme: theme,
      disabled: disabled,
      extend: extendWrapperStyle
    })
  }, before, /*#__PURE__*/React.createElement(Box, {
    grow: 1,
    shrink: 1,
    maxWidth: "100%"
  }, loading && /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    marginLeft: -4,
    extend: {
      position: 'absolute'
    }
  }, /*#__PURE__*/React.createElement(Loading, {
    size: 5
  })), hasLabel && /*#__PURE__*/React.createElement("span", {
    id: labelId,
    className: css(labelStyle)
  }, label), children(inputProps))), after), (errorMessage || description || maxlength) && /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justifyContent: errorMessage || description ? 'space-between' : 'flex-end',
    space: 2
  }, (errorMessage || description) && /*#__PURE__*/React.createElement(Box, {
    space: 0.5,
    shrink: 1
  }, errorMessage && /*#__PURE__*/React.createElement(Message, {
    type: "error"
  }, errorMessage), description && /*#__PURE__*/React.createElement(Message, null, description)), maxlength && /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    extend: {
      lineHeight: 1,
      fontSize: 12
    },
    color: value.length > maxlength ? 'foreground.destructive' : 'foreground.tertiary'
  }, value.length), /*#__PURE__*/React.createElement(Text, {
    color: "foreground.tertiary",
    extend: {
      lineHeight: 1,
      fontSize: 12
    }
  }, "\xA0/ ", maxlength))));
}